(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nea-video-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNeaVb(root) {
    if (root.getAttribute('data-nea-vb-ready')) return;
    root.setAttribute('data-nea-vb-ready', 'true');

    var video = root.querySelector('video');
    if (!video) return;

    video.muted = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  document.querySelectorAll('[data-nea-vb]').forEach(initNeaVb);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nea-video-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNeaVh(root) {
    if (root.getAttribute('data-nea-vh-ready')) return;
    root.setAttribute('data-nea-vh-ready', 'true');

    var slides = Array.prototype.slice.call(root.querySelectorAll('.nea-vh__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nea-vh-dot]'));
    var current = 0;
    var timer = null;

    if (slides.length === 0) return;

    function videoIn(slide) {
      return slide.querySelector('video');
    }

    function show(index) {
      clearTimeout(timer);
      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        if (dots[i]) dots[i].setAttribute('aria-current', active ? 'true' : 'false');

        var video = videoIn(slide);
        if (video) {
          if (active) {
            video.currentTime = 0;
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        }
      });

      // Slide bez videa prelazi sam nakon 5 sekundi
      if (!videoIn(slides[current])) {
        timer = setTimeout(function () { show(current + 1); }, 5000);
      }
    }

    slides.forEach(function (slide, i) {
      var video = videoIn(slide);
      if (video) {
        video.muted = true;
        video.addEventListener('ended', function () {
          if (i === current) show(i + 1);
        });
      }
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });

    show(0);
  }

  document.querySelectorAll('[data-nea-vh]').forEach(initNeaVh);
})();

  } catch(e) { console.error(e); }
})();
})();
